// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_WELFARE_REGIMES,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getWelfareRegimes = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('welfare_regimes')
      .then(
        (response) => {
          dispatch(GET_WELFARE_REGIMES, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/welfareRegimesActions.js